export default "__VITE_PUBLIC_ASSET__b2acfd1c__"